export default __webpack_public_path__ + "static/media/02.fb75680d.jpg";